export default __webpack_public_path__ + "static/howto-4-91537604ecea24b4eb524a5fa2bc8b0e.jpg";